import { useCallback, useMemo } from "react"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { serializeFusionError } from '@fusion-advantage/backcompat'
import { appointmentIsOnDay, DashboardLoadStatus, DashboardSelectionType, StatusedAppointment, statusedWorkItemKey, WorkItemType } from "@fusion-advantage/formlib"
import { V2L3ApptList, V2L2ApptListNavBar } from "@fusion-advantage/formrender"
import { setDashboardDisplayDate, setDashboardSelection } from "../../../redux/dashboardControlSlice"
import { selectDashboardListLoading } from "../../../redux/selectDashboardLoading"
import { DateTime } from "luxon"
import { appError } from "../../../redux/errorSlice"

export const LxApptList = () => {
	const loading = useAppSelector(selectDashboardListLoading)
	const itemsState = useAppSelector(state => state.dashboardData.workItems[WorkItemType.Appointment])
	const displayDate = useAppSelector(state => state.dashboardControl.displayDate)
	const filterByDate = useAppSelector(state => state.dashboardData.filterByDate)
	const startDate = useAppSelector(state => state.dashboardData.apptsStartDate)
	const endDate = useAppSelector(state => state.dashboardData.apptsEndDate)
	const selection = useAppSelector(state => state.dashboardControl.selection)
	const dispatch = useAppDispatch()
	const displayAppts = useMemo((): StatusedAppointment[] => {
		if(!itemsState.items) {
			return []
		}
		if(!filterByDate) {
			return itemsState.items
		}
		return itemsState.items.filter(({item}) => {
			return appointmentIsOnDay(item, displayDate)
		})
	}, [itemsState, displayDate])
	const handleMoveDaysClick = useCallback((days: number) => {
		const newDate = DateTime.fromISO(displayDate).plus({days}).toISODate()
		if(!newDate) {
			dispatch(appError({
				err: serializeFusionError('LxApptList', 'expected newDate but null'),
			}))
			return
		}
		dispatch(setDashboardDisplayDate(newDate))
	}, [displayDate, dispatch])
	const handleItemClick = useCallback((statused: StatusedAppointment) => {
		dispatch(setDashboardSelection({
			type: DashboardSelectionType.WorkItem,
			key: statusedWorkItemKey(statused),
		}))
	}, [dispatch])
	const displayDt = DateTime.fromISO(displayDate)
	const allApptsCount = itemsState.items?.length ?? 0
	return (
		<V2L3ApptList
			status={loading ? DashboardLoadStatus.Loading : itemsState.status}
			displayDate={displayDate}
			displayAppts={displayAppts}
			allApptsCount={allApptsCount}
			navBar={(
				<V2L2ApptListNavBar
					displayDate={displayDate}
					onMoveDaysClick={handleMoveDaysClick}
					canGoPrev={Boolean((allApptsCount > 0) && startDate && (DateTime.fromISO(startDate) < displayDt))}
					canGoNext={Boolean((allApptsCount > 0) && endDate && DateTime.fromISO(endDate) > displayDt)}
				/>
			)}
			selection={selection}
			onItemClick={handleItemClick}
		/>
	)
}
